import AboutHero from "../components/About/AboutHero";
import AboutFeature from "../components/About/AboutFeature";
import WhyChooseUs from "../components/About/WhyChooseUs";
export default function About() {
    return (
        <div>
         <AboutHero />
         <AboutFeature />
         <WhyChooseUs />

        </div>
    );
}
